import {useEffect, useRef, useState} from 'react'
import {Box} from '@mui/material'
import jsPDF from 'jspdf'
import {Helmet} from 'react-helmet'

import View from './view'

import Georgia from '../../fonts/Georgia.ttf'
import GeorgiaItalic from '../../fonts/Georgia-Italic.ttf'
import FlamaLight from '../../fonts/Flama-Light.ttf'
import FlamaMedium from '../../fonts/Flama-Medium.ttf'
import {GetConsultPdfResponse} from '../../redux/consult'

interface Props {
  landingId: string
  pdf: GetConsultPdfResponse
}

const ConsultPdf = ({landingId, pdf}: Props) => {
  const consultPdfRef = useRef<HTMLHtmlElement>(null)
  const [isLoadingPdf, setIsLoadingPdf] = useState(false)
  const [generatedPdfBlobUrl, setGeneratedPdfBlobUrl] = useState<
    string | undefined
  >(undefined)

  useEffect(() => {
    if (pdf && consultPdfRef.current) {
      setIsLoadingPdf(true)
      const doc = new jsPDF({
        unit: 'px',
        format: [796.8, 1123.19], // equivalent of 8.3in x 11.7in
      })

      // TODO: fix filename not being the name of the downloaded file
      const filename = `Black_Spectacles_Consultation_Summary--${pdf.info.name}--${landingId}`

      void doc.html(consultPdfRef.current, {
        callback: doc => {
          setGeneratedPdfBlobUrl(doc.output('bloburl').toString())
          setIsLoadingPdf(false)
        },
        filename,
        fontFaces: [
          {
            family: 'Flama',
            style: 'normal',
            src: [
              {
                url: FlamaLight,
                format: 'truetype',
              },
            ],
          },
          {
            family: 'Flama',
            style: 'italic',
            src: [
              {
                url: FlamaMedium,
                format: 'truetype',
              },
            ],
          },
          {
            family: 'Georgia',
            style: 'normal',
            src: [
              {
                url: Georgia,
                format: 'truetype',
              },
            ],
          },
          {
            family: 'Georgia',
            style: 'italic',
            src: [
              {
                url: GeorgiaItalic,
                format: 'truetype',
              },
            ],
          },
        ],
      })
    }
  }, [pdf, landingId])

  return (
    <>
      <Helmet>
        <title>{pdf.info.name} - PDF</title>
      </Helmet>
      <Box width="100vw" height="100vh">
        {/* The first and second conditions ensure that ConsultPdf will never
        appear unless the PDF generation errors out, but they can be removed
        for debugging purposes (e.g. finding out how each PDF page should look
        like). It still needs to be here because of the ref used on the
        generation, though. */}
        {!isLoadingPdf && !generatedPdfBlobUrl && (
          <View ref={consultPdfRef} {...pdf} />
        )}
        {!isLoadingPdf && generatedPdfBlobUrl && (
          <iframe
            src={generatedPdfBlobUrl}
            style={{width: '100%', height: '100%'}}
          />
        )}
      </Box>
    </>
  )
}

export default ConsultPdf
